<template>
  <div class="mb-nuo-container">
    <div v-if="!isChoosed" @click="chooseSeal" class="seal" :class="elecsealClassArr">
      <span class="sealIcon">+</span>
      <span>添加印章</span>
      <van-loading v-if="loading" class="upload-seal" color="#1989fa" type="spinner"/>
    </div>
    <!--已添加印章的展示-->
    <div v-else @click="chooseSeal" class="choose-seal" :class="elecsealClassArr" :style="{
        left: posX ? posX + 'px' : 0,
        top: posY ? posY + 'px' : 0,
      }">
      <img @touchmove="onmove" :src="seal.downloadUrl ? seal.downloadUrl: seal.sealBase64" class="choose-seal-img" />
    </div>
    <!--选择签章列表数据 -->
    <van-popup v-model="showList" position="right" :close-on-click-overlay="false" 
      :overlay-style="{'background-color':'rgba(0,0,0,.5)'}" :style="levelStyle"
      :get-container="getContainer">
      <seal-list-m v-if="showList" ref="sealListM" :sealConfigData="sealConfigData" @on-go-back="goBack" @choose-seal="handelConfirm" ></seal-list-m>
    </van-popup>
    <!--删除弹框、重新选择 -->
    <van-popup v-model="showDelete"  position="bottom" :close-on-click-overlay="false" :style="{ height: '22%' }">
      <div class="del-btns">
        <div class="del-btns-top">
          <div class="btn-common" v-if="canDelete"  @click="handelBtnDelete">删除</div>
          <van-divider />
          <div class="btn-common" @click="chooseSealAgain">重新选择</div>
        </div>
        <div class="del-btns-bottom btn-common" @click="handelBtnClose">取消</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import SealListM from './seal-list-m.vue'
export default {
  name: 'NuoSeal',
  components:{
    SealListM
  },
  props: {
    sealConfigData: {
      type: [Object, null],
      default: null
    },
    nuoSeal: null
  },
  computed:{
    levelStyle(){
       return {height:'100%',top:'0', right:'0', left:'0', transform:'inherit'}
    },
    canDelete() {
      if (this.nuoSeal) {
        return !this.nuoSeal?.emapFlowCommentCpmponentVm?.readonly
      } else {
        return true
      }
    },
    elecsealClassArr() {
      const arr = []
      if (this.nuoSeal?.emapFlowCommentCpmponentVm?.readonly) {
        arr.push('readonly')
      }else {
        arr.push('full')
      } 
      return arr
    }
  },
  data() {
    return {
      seal: {},
      posX: 0,
      posY: 0,
      loading:false,//上传签章
      isChoosed: false, // 是否选中章
      showList: false,//选择个人签章
      showDelete:false //删除
    }
  },
  watch: {
    'nuoSeal.emapFlowCommentCpmponentVm.chapterUrl'(val) { // 处理诺安数据回显的问题
      if (Array.isArray(val)) {
        this.echoSign(val)
      }
    }
  },
  methods:{
    /**
     * 弹框选择个人签章
     */
    async chooseSeal(e){
      if (!e || this.nuoSeal?.emapFlowCommentCpmponentVm?.readonly) return
      console.log(this.isChoosed,'chooseel');
      if (this.isChoosed) {
        this.showDelete = !this.showDelete
      } else {
        this.showList = true
      }
    },

    chooseSealAgain(e){
      if (!e || this.nuoSeal?.emapFlowCommentCpmponentVm?.readonly) return
      this.isChoosed = false;
      this.showList = true;
    },

    echoSign(chapterUrl = []) { // 回显印章(由emap-flow-comment组件调用)
      if (chapterUrl.length > 0) { // 诺安目前有且只有一个
        const url = chapterUrl[0]
        this.seal = {
          downloadUrl: url,
          url,
          isChoosed: true,
          sealId: '',
          signid: ''
        }
        this.isChoosed = true
        this.showList = false
      }
    },

    onmove(event) {
      //阻止默认事件，如果不添加，拖动时，内容会跟着跑。
      event.preventDefault()
      //拿到坐标
      var x = event.touches[0].clientX - 65
      var y = event.touches[0].clientY - 65
      // 为了取中心点，所以X轴和Y轴各减一半
      this.posX = x.toFixed(2)
      this.posY = y.toFixed(2)
    },

    goBack(){
      this.showList = false
    },

    handelConfirm(e) {
      this.showList = false
      this.showDelete = false
      if (!e || this.loading) return
        this.loading = true
        const error = this.$toast.error || alert
        this.nuoSeal.sign(e, (err, data) => {
        const emapFlowCommentCpmponentVm = this.nuoSeal.emapFlowCommentCpmponentVm
        this.loading = false
        if (err) {
          emapFlowCommentCpmponentVm.chapterWID = ''
          emapFlowCommentCpmponentVm.emitInput()
          return error(err?.msg || data?.msg || '添加异常')
        }
        emapFlowCommentCpmponentVm.chapterWID = data.datas.addJGSeal
        emapFlowCommentCpmponentVm.emitInput()
        this.isChoosed = true
        this.seal = e
        console.log(data)
      })
    },

    getContainer() {
      return document.querySelector('.mb-nuo-container')
    },

    handelBtnClose(){
      this.showDelete = false
    },

    handelBtnDelete(){
      this.$dialog.confirm({
      overlay:false,
      className:'delete-footer',
      message: '确定删除吗？',
    })
      .then(() => {
        this.posX = 0
        this.posY = 0
        this.seal = {}
        this.showDelete = false
        this.isChoosed = false
      })
      .catch(() => {
        console.log('取消删除');
      });
    }

  }
}
</script>
<style >
  .delete-footer .van-dialog__footer {
    display: flex;
  }
</style>
<style scoped>
.mb-nuo-container {
  overflow: hidden;
  height: 100%;
}
.choose-seal {
  position: relative;
  width: 100px;
  height: 100px;
}
.choose-seal .choose-seal-img {
  width: 100%;
  height: 100%;
}

.upload-seal {
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
    height: 100%;
    position: absolute;
    top: 0;
    width: 100%;
    background-color: rgba(255,255,255,0.7);
}
.upload-seal .van-loading__spinner {
  width: 20px;
  height: 20px;
}


.seal {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 4px;
  border: 1px solid #dddee1;
}

.seal.full{
  background-color: #f8f8f8;
  cursor: pointer;
  color: #316cf1;
}
.seal.readonly {
  cursor: not-allowed;
  color: #dddee1;
}

.seal span {
  display: block;
  text-align: center;
}

.seal .sealIcon {
  font-size: 38px;
  font-weight: bold;
  margin-top: 10px;
}

.seal-del-btn {
  position: absolute;
  bottom: -20px;
  width: 130px;
  height: 20px;
  background-color: #316cf1;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
}


.mb-nuo-container .del-btns {
  background-color: #f7f8fa;
  height: 100%;
  font-size: 16px;
  text-align: center;
}
.mb-nuo-container .del-btns .del-btns-top {
  height: calc(100% - 51px);
  background: #fff;
  width: 100%;
}
.mb-nuo-container .del-btns .del-btns-bottom {
  bottom: 0;
  width: 100%;
  position: fixed;
  background-color: #fff;
}
.mb-nuo-container .del-btns .btn-common {
  height: 46px;
  line-height: 40px;
  padding: 5px 0;
  box-sizing: border-box;
}
.mb-nuo-container .del-btns .van-divider {
  margin: 0;
}

</style>
